export default __webpack_public_path__ + "static/media/06AW3SEP66.552cffbf.jpg";